import { injectIntl as injectI18n } from "react-intl";
import I18nProvider from "./I18nProvider";
import I18nContext from "./I18nContext";
import I18n from './I18n';
import { useT, useI18n } from './hooks';
import { withT } from './hoc';

export default I18n;
export { I18nProvider, I18nContext, useI18n, useT, injectI18n, withT }
